document.addEventListener('DOMContentLoaded', () => {
    const openButtons = document.querySelectorAll('.request-form, .enquire-form');
    const drawers = document.querySelectorAll('.request_drawer, .enquire_drawer');

    if (!openButtons.length || !drawers.length) return;

    openButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
            drawers[index]?.classList.add('is_open');
        });
    });

    drawers.forEach(drawer => {
        const closeBtn = drawer.querySelector('.rd_close');

        closeBtn?.addEventListener('click', () => {
            drawer.classList.remove('is_open');
        });
    });

    document.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            drawers.forEach(drawer => drawer.classList.remove('is_open'));
        }
    });

    // Auto-open enquire drawer if URL has #open-enquire hash
    // (used by "Enquire Now" button on collection page cards)
    if (window.location.hash === '#open-enquire') {
        const enquireDrawer = document.querySelector('.enquire_drawer');
        if (enquireDrawer) {
            enquireDrawer.classList.add('is_open');
            // Clean the hash from URL without page reload
            history.replaceState(null, '', window.location.pathname + window.location.search);
        }
    }
});
document.addEventListener("DOMContentLoaded", function () {
    const headerTopMenu = document.querySelectorAll('.header_top .header_top_left .menu_item');
    const headerMainMenu = document.querySelectorAll('.header .header__column header-menu');
    const headerMainDrawer = document.querySelectorAll('.header__drawer');

    // Sync function to show correct main menu based on active top menu item
    function syncMainMenu(activeItem) {
        if (!activeItem) return false;
        const menuHandle = activeItem.getAttribute('data-menu');
        if (!menuHandle) return false;

        let hasValidDesktop = false;
        headerMainMenu.forEach((mainmenu) => {
            mainmenu.classList.remove("is_active");
            const mainmenuHandle = mainmenu.getAttribute('data-getmenu');
            if (menuHandle.trim().toLowerCase() === mainmenuHandle?.trim().toLowerCase()) {
                if (mainmenu.querySelectorAll('li').length > 0) {
                    hasValidDesktop = true;
                    mainmenu.classList.add("is_active");
                }
            }
        });

        headerMainDrawer.forEach((drawer) => {
            drawer.classList.remove("is_active");
            const drawerHandle = drawer.getAttribute('data-parent-menu');
            if (hasValidDesktop && menuHandle.trim().toLowerCase() === drawerHandle?.trim().toLowerCase()) {
                drawer.classList.add("is_active");
            }
        });

        // Save active menu to sessionStorage to persist across page reloads
        sessionStorage.setItem('activeHeaderMenu', menuHandle.trim().toLowerCase());

        return hasValidDesktop;
    }

    // Initialize: Check for custom override, then Liquid-set, then saved menu, then fallback to first
    let activeItem = null;

    if (!window.ignoreSectionNavigation) {
        if (window.customNavigationOverride && window.customNavigationHandle) {
            activeItem = document.querySelector(`.header_top .header_top_left .menu_item[data-menu="${window.customNavigationHandle}"]`);
            if (!activeItem && headerTopMenu.length > 0) {
                headerTopMenu.forEach(item => {
                    const itemMenu = item.getAttribute('data-menu');
                    if (itemMenu && (window.customNavigationHandle === itemMenu || window.customNavigationHandle.startsWith(itemMenu + '-') || window.customNavigationHandle.startsWith(itemMenu))) {
                        activeItem = item;
                    }
                });
            }
            if (activeItem) {
                sessionStorage.setItem('activeHeaderMenu', activeItem.getAttribute('data-menu'));
            }
        }

        if (!activeItem) {
            activeItem = document.querySelector('.header_top .header_top_left .menu_item.is_active');
            if (activeItem) {
                sessionStorage.setItem('activeHeaderMenu', activeItem.getAttribute('data-menu'));
            }
        }

        if (!activeItem) {
            const savedMenu = sessionStorage.getItem('activeHeaderMenu');
            if (savedMenu) {
                activeItem = document.querySelector(`.header_top .header_top_left .menu_item[data-menu="${savedMenu}"]`);
            }
        }
    }

    if (!activeItem && headerTopMenu.length > 0 && !window.ignoreSectionNavigation) {
        activeItem = headerTopMenu[0];
    }

    if (window.ignoreSectionNavigation) {
        // Clear all active states so the navigation defaults to the Spicers logo state
        headerTopMenu.forEach(el => el.classList.remove('is_active'));
        headerMainMenu.forEach(m => m.classList.remove('is_active'));
        headerMainDrawer.forEach(d => d.classList.remove('is_active'));
    } else if (activeItem) {
        headerTopMenu.forEach(el => el.classList.remove('is_active'));
        activeItem.classList.add('is_active');
        let isValid = syncMainMenu(activeItem);
        
        // Fallback to the second item ("Print") if the selected menu has no valid links
        if (!isValid && headerTopMenu.length > 1) {
            activeItem.classList.remove('is_active');
            activeItem = headerTopMenu[1];
            if (activeItem) {
                activeItem.classList.add('is_active');
                syncMainMenu(activeItem);
            }
        }
    }

    // Add click listener to save state when user switches menus
    headerTopMenu.forEach(function (item) {
        item.addEventListener("click", function (e) {
            if (window.customNavigationOverride) {
                const menuHandle = this.getAttribute('data-menu');
                let isBlank = true;
                headerMainMenu.forEach((mainmenu) => {
                    const mainmenuHandle = mainmenu.getAttribute('data-getmenu');
                    if (menuHandle && menuHandle.trim().toLowerCase() === mainmenuHandle?.trim().toLowerCase()) {
                        if (mainmenu.querySelectorAll('li').length > 0) {
                            isBlank = false;
                        }
                    }
                });

                if (isBlank) {
                    e.preventDefault();
                    return;
                }
            }

            headerTopMenu.forEach(function (el) {
                el.classList.remove("is_active");
            });
            if (!window.customNavigationOverride) {
                this.classList.add("is_active");
            }
            syncMainMenu(this);
        });
    });

    document.querySelectorAll('.header-drawer .menu-drawer-container').forEach((detail) => {
        detail.addEventListener('click', (event) => {
            if (detail.hasAttribute('open') && !event?.target.closest('.menu-drawer')) {
                detail.querySelector('.menu-drawer__close-button')?.dispatchEvent(new MouseEvent('click', {
                    bubbles: true
                }));
            }
        });
    });
});

document.querySelectorAll('.header_top-menu .menu_item').forEach(function (menuItem) {
    menuItem.addEventListener('click', function () {
        document.querySelectorAll('.header__drawer').forEach(function (drawer) {
            const menu = drawer.querySelector('.menu-drawer-container');
            if (menu) {
                menu.removeAttribute('open');
                menu.classList.remove('menu-open');
            }
        });
    });
});



document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
        document.querySelectorAll(
            '.header-menu__inner .menu-list__list-item .menu-list__link'
        ).forEach(function (el) {
            el.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll(
            '.header-menu__inner .menu-list__list-item .mega-menu'
        ).forEach(function (el) {
            el.classList.remove('active');
        });
        document.querySelectorAll('.header-menu').forEach(function (el) {
            el.setAttribute('aria-expanded', 'false');
            el.style.setProperty('--submenu-height', '0px');
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var threshold = 60;
    var swipeHandled = false;
    document.querySelectorAll(
        '.menu-drawer__menu.menu-drawer__menu--grandchildlist'
    ).forEach(function (submenu) {
        var startX = 0;
        var startY = 0;
        submenu.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        }, {
            passive: true
        });
        submenu.addEventListener('touchend', function (e) {
            var diffX = e.changedTouches[0].clientX - startX;
            var diffY = Math.abs(e.changedTouches[0].clientY - startY);
            if (diffX > threshold && diffY < 50) {
                swipeHandled = true;
                submenu.querySelector('.menu-drawer__back-button')?.click();
            }
        }, {
            passive: true
        });
    });
    document.querySelectorAll('.menu-drawer__inner-submenu')
        .forEach(function (submenu) {
            var startX = 0;
            var startY = 0;
            submenu.addEventListener('touchstart', function (e) {
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
            }, {
                passive: true
            });
            submenu.addEventListener('touchend', function (e) {
                if (swipeHandled) return;
                var diffX = e.changedTouches[0].clientX - startX;
                var diffY = Math.abs(e.changedTouches[0].clientY - startY);
                if (diffX > threshold && diffY < 50) {
                    swipeHandled = true;
                    submenu.querySelector('.menu-drawer__back-button')?.click();
                }
            }, {
                passive: true
            });
        });
    document.querySelectorAll('.menu-drawer-wrapper')
        .forEach(function (wrapper) {
            var startX = 0;
            var startY = 0;
            wrapper.addEventListener('touchstart', function (e) {
                swipeHandled = false;
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
            }, {
                passive: true
            });
            wrapper.addEventListener('touchend', function (e) {
                if (swipeHandled) return;
                var diffX = e.changedTouches[0].clientX - startX;
                var diffY = Math.abs(e.changedTouches[0].clientY - startY);
                if (diffX > threshold && diffY < 50) {
                    document
                        .querySelectorAll('#Details-menu-drawer-container')
                        .forEach(function (el) {
                            el.click();
                        });
                }
            }, {
                passive: true
            });
        });

    var threshold = 60;
    var swipeHandled = false;
    document.querySelectorAll('.cart-drawer__inner').forEach(function (drawer) {
        var startX = 0;
        var startY = 0;
        drawer.addEventListener(
            'touchstart',
            function (e) {
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
                swipeHandled = false;
            }, {
            passive: true
        }
        );
        drawer.addEventListener(
            'touchend',
            function (e) {
                var endX = e.changedTouches[0].clientX;
                var endY = e.changedTouches[0].clientY;
                var diffX = endX - startX;
                var diffY = Math.abs(endY - startY);
                if (diffX > threshold && diffY < 50 && !swipeHandled) {
                    swipeHandled = true;
                    var closeBtn = drawer.querySelector('.cart-drawer__close-button');
                    if (closeBtn) {
                        closeBtn.click();
                    }
                }
            }, {
            passive: true
        }
        );
    });


});

class HeaderSinglemenu extends HTMLElement {
    constructor() {
        super();
        this.menuHandle = this.closest('.mega-menu')?.getAttribute('data-parent-link');
        this.mainLink = this.closest('li.menu-list__list-item');
        this.mainHandle = this.mainLink?.querySelector('.menu-list__submenu')?.getAttribute('data-parent-link');
        if (this.menuHandle == this.mainHandle) {
            this.mainLink?.classList.add('simple_menu_nav');
        }
    }
}

customElements.define('header-singlemenu', HeaderSinglemenu);
class AdditionalCntmenu extends HTMLElement {
    constructor() {
        super();
        this.contents = this.querySelectorAll('[data-mobile-menu]');
        this.drawer = this.closest('header-drawer');
        this.contents?.forEach(element => {
            const getId = element.getAttribute('data-mobile-menu');
            this.menu = this.drawer?.querySelector(`#${getId} .menu-drawer__inner-submenu`);
            if (this.menu?.querySelector('.mobile_add_content')) {
                this.menu.querySelector('.mobile_add_content')?.append(element);
            } else {
                this.addHtml = document.createElement('div');
                this.addHtml.classList.add('mobile_add_content');
                this.addHtml.append(element);
                this.menu?.append(this.addHtml);
            }
        });
    }
}
customElements.define('additional-cntmenu', AdditionalCntmenu);
window.globalVerifyCart = async function (cart) {
    if (!cart || !cart.items || cart.items.length === 0) return;
    if (window._cartVerifyAttempted) return;

    // Check if grecaptcha is available
    let token = '';
    const captchaKey = window.theme?.ENV?.captcha_site_key || '6LextFosAAAAAH3nCeeqSd1g50XqeAfURZOt8Z6a';
    if (window.grecaptcha) {
        try {
            token = await new Promise(resolve => {
                grecaptcha.ready(() => grecaptcha.execute(captchaKey, { action: 'submit' }).then(resolve).catch(() => resolve('')));
            });
        } catch (e) {
            console.warn('[Global Verify] grecaptcha failed', e);
        }
    }

    let line = 0;
    const data = cart.items.map(i => ({
        line: ++line,
        cust_price: i.properties?._cust_price || '',
        price: i.properties?._price || '',
        hash: i.properties?._hmac || ''
    }));

    try {
        const verifyRes = await fetch(`${window.theme.ENV.apiUrl}/cart/verify`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '1' },
            body: JSON.stringify(data)
        });
        const result = await verifyRes.json();

        if (result && !result.valid && result.invalidLine && result.invalidLine.length > 0) {
            console.log('[Global Verify] Invalid lines found, auto-fixing...', result.invalidLine);
            window._cartVerifyAttempted = true;

            const customerSapId = window.customer?.sapId || '143282';
            const session = window.ShopifyAnalytics?.lib?.user?.()?.traits?.()?.uniqToken || '';

            let variantsToQuote = [];
            let linesToFix = [];

            result.invalidLine.forEach(l => {
                const invalidItem = cart.items[l - 1];
                if (invalidItem) {
                    const material = invalidItem.properties?._material || invalidItem.sku?.replace('SKU:', '').trim() || '';
                    let prm = invalidItem.properties?._prm || invalidItem.properties?.prm || '';

                    // Do not quote items without PRM natively
                    if (prm) {
                        variantsToQuote.push({
                            variantId: invalidItem.variant_id,
                            qty: invalidItem.properties?.qty || invalidItem.quantity || 1,
                            material: material,
                            prm: prm
                        });
                        linesToFix.push({ line: l, item: invalidItem });
                    } else {
                        // Just do a native update to clear bad properties if needed, or skip.
                        linesToFix.push({ line: l, item: invalidItem, skipQuote: true });
                    }
                }
            });

            if (variantsToQuote.length > 0) {
                const quoteRes = await fetch(`${window.theme.ENV.apiUrl}/cart?token=${token}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '1' },
                    body: JSON.stringify({
                        variants: variantsToQuote,
                        session,
                        token: 'KIi16KkJ3HEjwydO7S582tKkESRZJsaJDlH2ckDXZ1OJjmHp6W',
                        customer: customerSapId
                    })
                });
                const quoteData = await quoteRes.json();
                const items = Array.isArray(quoteData) ? quoteData : [quoteData];

                if (items.length > 0) {
                    let quoteIndex = 0;
                    for (const fixObj of linesToFix) {
                        let updates = {};
                        if (!fixObj.skipQuote) {
                            const apiItem = items[quoteIndex++];
                            if (apiItem && apiItem.properties) {
                                updates = {
                                    quantity: fixObj.item.quantity,
                                    properties: { ...fixObj.item.properties, ...apiItem.properties, qty: apiItem.qty, _hmac: apiItem.hmac }
                                };
                            }
                        } else {
                            updates = {
                                quantity: fixObj.item.quantity,
                                properties: { ...fixObj.item.properties } // native update
                            };
                        }

                        // Shopify's /cart/change.js requires sequential updates to not drop requests
                        await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: fixObj.item.key,
                                quantity: updates.quantity,
                                properties: updates.properties
                            })
                        });
                    }

                    // Re-trigger cart drawer refresh to update UI instantly!
                    if (typeof refreshCartDrawer === 'function') {
                        setTimeout(() => refreshCartDrawer(), 500);
                    } else {
                        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
                    }
                }
            }
        }
    } catch (e) {
        console.error('[Global Verify] Error:', e);
    }
};



async function refreshCartDrawer() {
    const currentTime = Date.now();
    const sectionsToUpdate = 'cart-drawer-section';
    const sectionUrl = window.location.pathname + `?sections=${sectionsToUpdate}&t=${currentTime}`;

    import('@theme/events').then(({ CartUpdateEvent }) => {
        const cartDrawer = document.querySelector('cart-drawer-component');

        // Parallel fetch for cart data and updated sections HTML
        Promise.all([
            fetch(`/cart.js?t=${currentTime}`, { headers: { 'Cache-Control': 'no-cache' } }).then(res => res.json()),
            fetch(sectionUrl, { headers: { 'Cache-Control': 'no-cache' } }).then(res => res.json())
        ])
            .then(([cart, sections]) => {
                console.log('[Cart Refresh] Data:', cart, '| Sections received:', !!sections[sectionsToUpdate]);

                // Run global verification asynchronously so it doesn't block UI refresh initially
                if (typeof window.globalVerifyCart === 'function') {
                    window.globalVerifyCart(cart);
                }

                const event = new CartUpdateEvent(cart, 'manual-trigger', {
                    itemCount: cart.items.length,
                    source: 'fad-refresh',
                    sections: sections || {},
                    carttotal: cart.total_price
                });
                document.dispatchEvent(event);

                setTimeout(() => {
                    cartDrawer?.open?.();
                }, 200);
            })
            .catch(err => console.error('[Cart Refresh] Error:', err));
    });
}

const wc_money_formate = document.querySelector('[data-wc_money_formate]')?.getAttribute('data-wc_money_formate');
/**
 * @param {string} wc_money_formate
 * @param {number} amount  // in cents
 * @returns {string}
 */
function replaceAmount(wc_money_formate, amount) {
    const money = (amount / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })

    return wc_money_formate.replace('{{amount}}', money)
}
/**
 * @param {string} formattedMoney
 */
function getfullAmount(formattedMoney) {
    const numeric = formattedMoney.replace(/[^0-9.-]/g, '')
    return Math.round(parseFloat(numeric) * 100)
}


if (navigator.userAgent.indexOf('iPhone') > -1) {
    document.querySelector("[name=viewport]").setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1");
}

// mobile menu js
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.menu-drawer__menu.has-submenu li.menu-drawer__list-item .summary-div').forEach(function (el) {
        el.addEventListener('click', function () {
            var parentLi = this.closest('li.menu-drawer__list-item');
            if (parentLi) parentLi.classList.add('active');
        });
    });
    document.querySelectorAll('.menu-drawer__submenu li.menu-drawer__list-item .inner-summary-div').forEach(function (el) {
        el.addEventListener('click', function () {
            var parentLi = this.closest('li.menu-drawer__list-item');
            if (parentLi) parentLi.classList.add('active');
        });
    });
    document.querySelectorAll('.menu-drawer__menu.has-submenu li.menu-drawer__list-item .menu-drawer__submenu .menu-drawer__nav-buttons').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var parentLi = this.closest('li.menu-drawer__list-item');
            if (parentLi) parentLi.classList.remove('active');
        });
    });
    document.querySelectorAll('.menu-drawer__submenu li.menu-drawer__list-item .menu-drawer__back-button').forEach(function (el) {
        el.addEventListener('click', function () {
            var parentLi = this.closest('li.menu-drawer__list-item');
            if (parentLi) parentLi.classList.remove('active');
        });
    });
});
document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.menu-drawer__close-button');
    if (!closeBtn) return;
    document.querySelectorAll('header-drawer .active').forEach(el => el.classList.remove('active'));
});


if (window.innerWidth < 768) {
    document.addEventListener('DOMContentLoaded', function () {
        const drawer = document.querySelector('.cart-drawer__dialog');
        if (!drawer) return;
        let scrollY = 0;

        function lockBody() {
            scrollY = window.scrollY;
            document.body.classList.add('cart-drawer-open');
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
        }

        function unlockBody() {
            document.body.classList.remove('cart-drawer-open');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            window.scrollTo(0, scrollY);
        }
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                    if (drawer.hasAttribute('open')) {
                        lockBody();
                    } else {
                        unlockBody();
                    }
                }
            });
        });
        observer.observe(drawer, {
            attributes: true
        });
    });
}

(function () {
    if (window.innerWidth >= 768) return;

    var base = 100;
    var scrollY = 0;

    document.addEventListener('DOMContentLoaded', function () {
        var drawers = document.querySelectorAll('.menu-drawer-container');
        if (!drawers.length) return;

        function lockBody() {
            scrollY = window.scrollY;

            document.documentElement.classList.add('menu-lock');
            document.body.classList.add('menu-lock');

            document.body.style.position = 'fixed';
            document.body.style.top = -scrollY + 'px';
            document.body.style.width = '100%';
        }

        function unlockBody() {
            document.documentElement.classList.remove('menu-lock');
            document.body.classList.remove('menu-lock');

            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';

            window.scrollTo(0, scrollY);
        }

        // Observe all drawers
        drawers.forEach(function (drawer) {
            var observer = new MutationObserver(function () {
                if (drawer.classList.contains('menu-open')) {
                    lockBody();
                } else {
                    unlockBody();
                }
            });

            observer.observe(drawer, {
                attributes: true
            });
        });

        function handleScroll() {
            var realScroll = document.body.classList.contains('menu-lock') ?
                scrollY :
                window.scrollY || window.pageYOffset;

            document
                .querySelectorAll('.scroll-up-sticky header-drawer .menu-drawer')
                .forEach(function (el) {
                    if (realScroll <= base) {
                        var topVal = base - realScroll;
                        el.style.top = topVal + 'px';
                        el.style.height = 'calc(100dvh - ' + topVal + 'px)';
                    } else {
                        el.style.top = '';
                        el.style.height = '';
                    }
                });
        }

        window.addEventListener('scroll', handleScroll);
        handleScroll();
    });
})();

(function () {
    const nav =
        performance.getEntriesByType("navigation")[0] || performance.navigation;
    if (nav.type === "back_forward") {
        window.location.reload();
    }
})();